import e from"react";import r from"./styles.module.scss.js";var t=function(){return e.createElement("div",{className:r.container})};export{t as default};
//# sourceMappingURL=index.js.map
